(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["about-certifications-content"] && !Shopify.designMode) return;
  try {
    class MateAboutCertifications extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    select(id, focus = false) {
      this.querySelectorAll('[data-certification-tab]').forEach((tab) => {
        const active = tab.dataset.certificationTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      this.querySelectorAll('[data-certification-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.certificationPanel !== id;
      });
    }

    handleClick = (event) => {
      const tab = event.target.closest('[data-certification-tab]');
      if (!tab || tab.closest('mate-about-certifications') !== this) return;
      this.select(tab.dataset.certificationTab);
    };

    handleKeydown = (event) => {
      const tab = event.target.closest('[data-certification-tab]');
      if (!tab || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      const tabs = [...this.querySelectorAll('[data-certification-tab]')];
      let index = tabs.indexOf(tab);
      if (event.key === 'ArrowDown') index = (index + 1) % tabs.length;
      if (event.key === 'ArrowUp') index = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = tabs.length - 1;
      event.preventDefault();
      this.select(tabs[index].dataset.certificationTab, true);
    };

    handleBlockSelect = (event) => {
      const tab = this.querySelector(`[data-certification-tab="${event.detail?.blockId}"]`);
      if (tab) this.select(tab.dataset.certificationTab);
    };
  }

  if (!customElements.get('mate-about-certifications')) {
    customElements.define('mate-about-certifications', MateAboutCertifications);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["about-packaging-content"] && !Shopify.designMode) return;
  try {
    class MateAboutPackaging extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      const selected = this.querySelector('[data-packaging-tab][aria-selected="true"]')
        || this.querySelector('[data-packaging-tab]');
      if (selected) this.select(selected.dataset.packagingTab);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    select(id, focus = false) {
      this.querySelectorAll('[data-packaging-tab]').forEach((tab) => {
        const active = tab.dataset.packagingTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      this.querySelectorAll('[data-packaging-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.packagingPanel !== id;
      });
      this.querySelectorAll('[data-packaging-detail]').forEach((detail) => {
        detail.hidden = detail.dataset.packagingDetail !== id;
      });
    }

    handleClick = (event) => {
      const tab = event.target.closest('[data-packaging-tab]');
      if (!tab || tab.closest('mate-about-packaging') !== this) return;
      this.select(tab.dataset.packagingTab);
    };

    handleKeydown = (event) => {
      const tab = event.target.closest('[data-packaging-tab]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const tabs = [...this.querySelectorAll('[data-packaging-tab]')];
      const currentIndex = tabs.indexOf(tab);
      const rtl = getComputedStyle(this).direction === 'rtl';
      let nextIndex;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex + (rtl ? 1 : -1) + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + (rtl ? -1 : 1)) % tabs.length;
      if (nextIndex === undefined) return;
      event.preventDefault();
      this.select(tabs[nextIndex].dataset.packagingTab, true);
    };
  }

  if (!customElements.get('mate-about-packaging')) {
    customElements.define('mate-about-packaging', MateAboutPackaging);
  }
  } catch(e) { console.error(e); }
})();

})();
